import { observer } from "mobx-react-lite"
import { FC, useContext, useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { Context } from "../.."
import Modal from "../../components/Modal"

import styles from "../../styles/AdminManager.module.scss"

import HomeManager from "./manager/HomeManager"
import AboutManager from "./manager/AboutManager"
import ContactsManager from "./manager/ContactsManager"
import ProjectsManager from "./manager/ProjectsManager"
import CoreManager from "./manager/CoreManager"
import useWindowDimensions from "../../core/hooks/useWindowDimensions"

enum ManagerPage {
  HOME = "HOME",
  PROJECTS = "PROJECTS",
  ABOUT = "ABOUT",
  CONTACTS = "CONTACTS",
  SETTINGS = "SETTINGS"
}

const ManagerPageTitle = {
  HOME: "Главная", PROJECTS: "Проекты", ABOUT: "О нас", CONTACTS: "Контакты", SETTINGS: "Сменить пароль"
}

const AdminManager: FC = () => {

  const { store, adminStore } = useContext(Context)
  const location = useLocation()

  const { width } = useWindowDimensions()

  const [page, setPage] = useState(ManagerPage.HOME as ManagerPage)
  const [pageTitle, setPageTitle] = useState(ManagerPageTitle.HOME as string)
  
  const [isLogoutVisible, setIsLogoutVisible] = useState(false)
  const [visible, setVisible] = useState(false)
  const [visibleOp, setVisibleOp] = useState(false)

  const [menuOpenned, setMenuOpenned] = useState(false)

  const openMenu = () => {
    setMenuOpenned(prev => prev = !prev)
  }

  const openManager = () => {
    setVisible(prev => prev = true)
    if (location.pathname === "/about") {
      setPage(ManagerPage.ABOUT)
    } else if (location.pathname.includes("/projects")) {
      setPage(ManagerPage.PROJECTS)
    } else if (location.pathname === "/contacts") {
      setPage(ManagerPage.CONTACTS)
    } else {
      setPage(ManagerPage.HOME)
    }

    document.body.style.overflowY = 'hidden'
    document.getElementsByTagName("html")[0].style.overflowY = 'hidden'

    setTimeout(() => {
      setVisibleOp(prev => prev = true)
    }, 100)
  }
  
  const closeManager = () => {
    setVisibleOp(prev => prev = false)
    
    document.body.style.overflowY = 'unset'
    document.getElementsByTagName("html")[0].style.overflowY = 'unset'
    
    setTimeout(() => {
      setVisible(prev => prev = false)
    }, 300)
  }

  const logout = () => {
    store.logout()
    window.location.reload()
  }

  useEffect(() => {
    setPageTitle(prev => prev = ManagerPageTitle[page])
    setMenuOpenned(prev => prev = false)
  }, [page])

  useEffect(() => {
    
  }, [])

  return (
    <>
      <div 
        className={styles.manager_btn + (store.theme === "winter" && !location.pathname.includes("/summer") ? " " + styles.winter : "")}
        onClick={() => openManager()}><div><i className="fas fa-wrench"></i></div></div>
    
      <div className={styles.manager} style={{opacity: visibleOp ? "1" : "0", display: visible ? "flex" : "none"}}>
        <div className={styles.manager_wrap}>
          <div className={styles.manager_sidebar}>
            <div className={styles.manager_sidebar__logo}>MAINBURO <b>CMS</b></div>
            <div className={styles.manager_sidebar__menu + (menuOpenned ? " " + styles.openned : "")}>
              <div className={page === ManagerPage.HOME ? styles.active : ""} onClick={() => setPage(ManagerPage.HOME)}>{ManagerPageTitle.HOME}</div>
              <div className={page === ManagerPage.PROJECTS ? styles.active : ""} onClick={() => setPage(ManagerPage.PROJECTS)}>{ManagerPageTitle.PROJECTS}</div>
              <div className={page === ManagerPage.ABOUT ? styles.active : ""} onClick={() => setPage(ManagerPage.ABOUT)}>{ManagerPageTitle.ABOUT}</div>
              <div className={page === ManagerPage.CONTACTS ? styles.active : ""} onClick={() => setPage(ManagerPage.CONTACTS)}>{ManagerPageTitle.CONTACTS}</div>
              
              {width < 768 ? <>
                <div className={page === ManagerPage.SETTINGS ? styles.active : ""} onClick={() => setPage(ManagerPage.SETTINGS)}>{ManagerPageTitle.SETTINGS}</div>
                <div className={""} onClick={() => setIsLogoutVisible(true)}>Выйти</div>
              </> : <></>}
            </div>
            <div className={styles.manager_sidebar_cwp + (page === ManagerPage.SETTINGS ? " " + styles.active : "")} onClick={() => setPage(ManagerPage.SETTINGS)}><i className="fas fa-unlock"></i> {ManagerPageTitle.SETTINGS}</div>
            <div className={styles.manager_sidebar__logout} onClick={() => setIsLogoutVisible(true)}><i className="fas fa-right-from-bracket"></i> Выйти</div>
            <div className={styles.manager_sidebar__mn + (menuOpenned ? " " + styles.openned : "")} onClick={() => openMenu()}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="6" width="20" height="1" fill={"#fff"}/>
                <rect y="13" width="20" height="1" fill={"#fff"}/>
              </svg>
            </div>
          </div>
          <div className={styles.manager_body}>
            <div className={styles.manager_body__header}>
              <div className={styles.mbh_title}>
                <div>Панель Управления</div>
                <div>{pageTitle}</div>
              </div>
              <div className={styles.mbh_close} onClick={() => closeManager()}><i className="fas fa-xmark"></i></div>
            </div>
            <div className={styles.manager_body__content}>
              {page === ManagerPage.HOME ? <HomeManager /> : <></>}
              {page === ManagerPage.PROJECTS ? <ProjectsManager /> : <></>}
              {page === ManagerPage.ABOUT ? <AboutManager /> : <></>}
              {page === ManagerPage.CONTACTS ? <ContactsManager /> : <></>}
              {page === ManagerPage.SETTINGS ? <CoreManager /> : <></>}
            </div>
          </div>
        </div>
      </div>

      <Modal
        visible={isLogoutVisible}
        title="Выйти из ПУ"
        content={<>
          <div className="modal_text">
            <p>Вы действительно хотите выйти из Панели Управления сайтом?</p>
          </div>
          <div className="modal_action">
            <div>
              <button onClick={() => logout()} style={{marginBottom: "0px"}}>Выйти</button>
            </div>
          </div>
        </>}
        onClose={() => setIsLogoutVisible(false)} />
    </>
  )
}

export default observer(AdminManager)